
// Required packages: axios, react-router-dom, react-i18next, bootstrap

import React, { useEffect, useState, useCallback } from 'react';
// import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { FaAngleLeft } from 'react-icons/fa';

import {useLoading} from '../../components/LoadingProvider';


import { getActivePlantGroups } from '../../services/plants/publicPlantsService';

const PlantGroups = () => {
  const [groups, setGroups] = useState([]);
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

    const { showLoading, hideLoading, toast } = useLoading();
  
  const BASE_URL = process.env.REACT_APP_BASE_URL;







  // const handleLanguageChanged = useCallback(() => {

  //   loadPlantsGroups();
  //   console.log('Language changed to:', i18n.language);
  // }, []);

  useEffect(() => {

    // i18n.on('languageChanged', handleLanguageChanged);

    loadPlantsGroups();

    // return () => {
    //   i18n.off('languageChanged', handleLanguageChanged);
    // };
  }, [i18n.language]);



 


  const loadPlantsGroups = ()=>{


     showLoading();

      getActivePlantGroups()
      .then(list=>{
          console.log('DATA ::: ',list)

          const groups = list.map(g=>  ({
              id: g._id,
              title: g.name,
              imageUrl: g.image ? BASE_URL + g.image  :  "https://picsum.photos/350?random=232323" 
          }));

        setGroups(groups);

      })
      .catch(err=>{ 
          console.log('ERROR ::: ',err)
          toast.error('Error on loading Plant Group!')
       })
      .finally(()=>{
          hideLoading()
      })

  }


  // useEffect(() => {
  
  //   loadPlantsGroups();

    
    
  // }, []);

  const handleBack = () => {
    navigate(-1); // یا مسیر خاص مثل: navigate('/groups');
  };

  return (
    <div className="container py-4">

     

     <div className="d-flex justify-content-between align-items-center mb-4">
          <h2 className="mb-0">{t('botany.groupPlantsTitle')}</h2>
          <button className="btn btn-outline-secondary rounded-pill px-3" onClick={handleBack}>
            <FaAngleLeft/>
             {t('common.back')}
          </button>
    </div>


      <div className="row g-3">
        {groups.map(group => (
          <div className="col-12 col-md-4 col-lg-3" key={group.id}>
            <div
              className="card h-100 shadow border-0 bg-success-subtle text-dark tile-button"
              onClick={() => navigate(`/plants/group/${group.id}`)}
              style={{ cursor: 'pointer' }}
            >
              <img
                src={group.imageUrl}
                alt={group.title}
                className="card-img-top"
                style={{ objectFit: 'cover', height: '150px' }}
              />
              <div className="card-body text-center">
                <h5 className="card-title">{group.title}</h5>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PlantGroups;
